var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"id":"about","tag":"section"}},[_c('div',{staticClass:"mypagetitle"},[_vm._v("ABOUT")]),_c('display-page-summary',{attrs:{"mysummary":_vm.mysummary}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }